<template>
  <div id="sequence_tasks_analytics" class="flex flex-col gap-2">
    <TasksAnalyticsGrid />
    <TaskActivityGraph />
  </div>
</template>

<script setup>
import TaskActivityGraph from "@/src/views/analytics/v2/sequence_analytics/tasks/TaskActivityGraph.vue";
import TasksAnalyticsGrid from "@/src/views/analytics/v2/sequence_analytics/tasks/TasksAnalyticsGrid.vue";
</script>
